import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import SubscriptionAddChild from "./SubscriptionCollectionAddChild";

const SubscriptionAdd = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <SubscriptionAddChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default SubscriptionAdd;
